<template>
    <div class="profile-pic-cropper-wrapper">
        <input type="file" ref="file" @change="uploadImage($event)" accept="image/*">
        
        <v-card v-if="!image" height="300" flat tile @click="$refs.file.click()">
            <v-container fill-height justify-center>
                <div class="text-center">
                    <v-icon size=50 color="grey lighten-1">mdi-camera-plus-outline</v-icon>
                    <span class="d-block grey--text title d-block font-weight-light">
                        Add Pic
                    </span>
                </div>
            </v-container>
            <svg class="placeholder__svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                <rect fill="none" :stroke="$vuetify.theme.themes.light.secondaryDarker" x="0" y="0" width="100%" height="100%" stroke-dasharray=10 ref="placeholderRect" />
            </svg>
        </v-card>
        <v-card v-else flat tile>
            <div class="d-flex justify-center imageready__loader" v-if="!imageReady">
                <v-progress-circular indeterminate color="grey" size="20"></v-progress-circular>
            </div>
            <Cropper ref="cropper" 
            classname="profile-pic-cropper" 
            :src="image"
            :restrictions="pixelsRestriction"
            :minHeight="100"
            :minWidth="100"
            :stencil-props="{
                aspectRatio: 1
            }"
            @ready="imageReady = true"
            />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.prevent="$refs.file.click()" color="blue darken-1" class="text-capitalize" 
                :disabled="loading || !imageReady">Change Image</v-btn>
                <v-btn text @click.prevent="crop" class="text-capitalize" color="blue darken-1" :loading="loading"
                :disabled="loading || !imageReady">Save Image</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<style scoped>
input[type='file'] {
  display: none;
}
.profile-pic-cropper {
    height: 300px;
    width: 100%;
}
.placeholder__svg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translateX(-50%) translateY(-50%);
}

.imageready__loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 9;
    transform: translateX(-50%) translateY(-50%);
}
</style>
<script>
import { Cropper } from 'vue-advanced-cropper'

export default {
    props: {
        originalImage: String,
        croppedImageUniqueTo: String,
        loading: Boolean
    },
    data() {
        return {
            coordinates: {
              width: 0,
              height: 0,
              left: 0,
              top: 0
            },
            image: this.originalImage ? this.originalImage : null,
            croppedImage: null,
            imageReady: false
        }
    },
    methods: {
        uploadImage(event) {
            // Reference to the DOM input element
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0]) {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader()
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.image = e.target.result
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0])
            }
        },
        /* eslint-disable */
        pixelsRestriction({ minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight }) {
            return {
                minWidth: minWidth,
                minHeight: minHeight,
                maxWidth: maxWidth,
                maxHeight: maxHeight
            }
        },

        crop() {
            const { coordinates, canvas } = this.$refs.cropper.getResult()
            const maxRes = 200
            this.coordinates = coordinates
            if(canvas) {
                
                const tmpCanvas = document.createElement('canvas')
                tmpCanvas.width = maxRes
                tmpCanvas.height = maxRes
                const ctx = tmpCanvas.getContext('2d')
                ctx.drawImage(canvas,0,0,canvas.width,canvas.height,0,0,tmpCanvas.width,tmpCanvas.height)
                ctx.canvas.toBlob((blob) => {
                    const name = this.croppedImageUniqueTo ? `${new Date().getTime()}-pic-for-${this.croppedImageUniqueTo}` : 'cropped-pic'
                    const croppedFile = new File([blob], `${name}.jpg`, {
                        name: 'cropped',
                        type: 'image/jpg',
                        lastModified: Date.now()
                    }, 0.80)
                    this.croppedImage = croppedFile
                    this.$emit('cropped', this.croppedImage)
                })
            } 
            
        }
    },
    components: {
        Cropper
    }
}
</script>